import { type Location, Navigate, useLocation } from "react-router";

interface RedirectProps {
  /** Relative or absolute path to redirect to, resolved like `Navigate`'s `to`. */
  to: string;
}

/**
 * Replaces the current history entry with `to`, carrying the current search string and history
 * state along. Use it for index routes that forward to a default child so anything a caller
 * attached to the URL, such as the `?query=` prompt and the files the dashboard chat box hands to
 * a new draft, still reaches the page that reads it.
 */
export default function Redirect({ to }: RedirectProps) {
  const location: Location<unknown> = useLocation();
  return <Navigate to={{ pathname: to, search: location.search }} state={location.state} replace />;
}
